export const normalizeBooleanValue = (value: unknown): boolean => {
    if (typeof value === "boolean") {
        return value;
    }

    if (typeof value === "number") {
        return value !== 0;
    }

    if (typeof value === "string") {
        const normalizedValue = value.trim().toLowerCase();

        if (["false", "0", "no", "n", "off", ""].includes(normalizedValue)) {
            return false;
        }

        if (["true", "1", "yes", "y", "on"].includes(normalizedValue)) {
            return true;
        }
    }

    return Boolean(value);
};
